import React from 'react'
import { LockIcon } from 'lucide-react'
import { toast } from 'sonner'

import { ampli } from '@/shared/lib/ampli'
import { cn } from '@/shared/lib/utils'

export function BasicLockEditableField({
	isDirty,
	onChange,
	value,
	disabled,
	disabledReason,
}: {
	isDirty: boolean
	onChange: (value: boolean) => void
	value: boolean
	disabled?: boolean
	disabledReason?: string
}) {
	const lockCurrentPrice = () => {
		if (disabled) {
			toast.warning(disabledReason ?? 'You are not allowed to edit this field')

			return
		}
		ampli.tableLockPrice()
		onChange?.(!value)
	}

	return (
		<div
			className={cn(
				'flex w-full cursor-pointer items-center',
				!value && 'group'
			)}
			onClick={lockCurrentPrice}
		>
			<LockIcon
				className={cn(
					'size-3 cursor-pointer',
					isDirty && value
						? 'text-primary'
						: value
							? 'text-muted-foreground'
							: 'text-accent-5 invisible group-hover:visible'
				)}
			/>
		</div>
	)
}
